import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getDeliveryCountriesApi } from './getDeliveryCountries.api'
import getDeliveryCountriesInitialState from './getDeliveryCountries.initialState'
import { GetDeliveryCountriesErrorResponse, GetDeliveryCountriesRequestPayload } from './getDeliveryCountries.types'

export const getDeliveryCountries = createAsyncThunk(
  urls.offers.getDeliveryCountries,
  async (payload: GetDeliveryCountriesRequestPayload, { rejectWithValue }) => {
    const { onSuccess } = payload

    try {
      const response = await getDeliveryCountriesApi()

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getDeliveryCountriesSlice = createSlice({
  name: urls.offers.getDeliveryCountries,
  initialState: getDeliveryCountriesInitialState,
  reducers: {
    resetGetDeliveryCountries: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }

    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDeliveryCountries.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getDeliveryCountries.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getDeliveryCountries.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetDeliveryCountriesErrorResponse
        state.success = null
      })
  }
})

export const { actions: getDeliveryCountriesActions, reducer: getDeliveryCountriesReducer } = getDeliveryCountriesSlice
export const { resetGetDeliveryCountries } = getDeliveryCountriesActions
export default getDeliveryCountriesSlice.reducer
